import axios from "axios";

const frequency = parseInt(process.env.VUE_APP_VERSION_CHECK_INTERVAL) || 120000;
const versionUrl = process.env.VUE_APP_VERSION_FILE_URL || "./version.json";

let currentBuild = null;
let intervalId = null;

function fetchVersion() {
  return axios
    .get(versionUrl, { params: { t: Date.now() } })
    .then((res) => res.data);
}

export function initVersionCheck(onNewVersionAvailable) {
  fetchVersion()
    .then((data) => {
      currentBuild = data.build;

      intervalId = setInterval(() => {
        fetchVersion()
          .then((latest) => {
            if (latest && currentBuild && latest.build > currentBuild) {
              onNewVersionAvailable();
              stopVersionCheck();
            }
          })
          .catch((err) =>
            console.error("Impossibile controllare la versione", err)
          );
      }, frequency);
    })
    .catch((err) =>
      console.error("Impossibile recuperare la versione iniziale", err)
    );
}

export function stopVersionCheck() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
